import { TagFilterInput } from "../../../features/search/types"
import {
  CheckboxFilterOption,
  FilterCategory,
} from "../components/filters/types"
import { expandTreeOptions } from "./filters"

const toTagFilterInput = (item: FilterCategory): TagFilterInput => ({
  key: item.key,
  codes:
    expandTreeOptions((item?.options as CheckboxFilterOption[]) ?? [])
      .filter((x) => x.selected)
      .map((x) => x.code) ?? [],
})

export const convertToFilterTags = (
  items: FilterCategory[]
): TagFilterInput[] =>
  items.map(toTagFilterInput).filter((x) => x.codes.length > 0)
